/* eslint-disable no-unused-vars */
import { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'dva';
import { useLocation, history } from 'umi';
import qs from 'qs';
import classnames from 'classnames';
import dayjs from 'dayjs';
import SearchGroup from './components/search_group/SearchGroup';
import TablePage from './components/table_page/TablePage';
import ButtonML from '@/components/button_ml/ButtonML';
import ModalML from '@/components/modal_ml/ModalML';
// import AddMember from './add/components/add_member/AddMember';
import ActionBtnGroup from './components/action_group/ActionBtnGroup';
import IndexStyled from './IndexStyled.jsx';

const MemberManagement = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const { query, pathname } = location;
  // 结构到所有查询条件，包括分页条件
  const {
    channel,
    gender,
    memberCode,
    mobile,
    name,
    signUpDateEnd,
    signUpDateStart,
    registerStore,
    manageStore,
    level,
    refreshTime,
    pageNum = '1',
    pageSize = '10',
  } = query;
  // console.log('query', query);
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['adjustList/getMemberList'];
  const { memberPageList, allTotal } = useSelector((state) => state.adjustList);
  const levels = useSelector((state) => state.adjustList.levels);

  const [modalVisible2, setVisible2] = useState(false);
  const [memberInfo, setMemberInfo] = useState({});

  const [column, setColumn] = useState();
  const [sort, setSort] = useState();
  const searchRef = useRef();
  const [isSearch, setIsSearch] = useState(false);
  // 查询事件处理
  const handleSearch = (newParam) => {
    setIsSearch(true);
    const time = dayjs().format('YYYY-MM-DD HH:mm:ss');
    console.log(
      '💢felix => handleSearch => newParam',
      `${pathname}?${qs.stringify({
        ...newParam,
        pageSize,
        pageNum: 1,
      })}`,
    );
    history.replace(
      `${pathname}?${qs.stringify({
        ...newParam,
        refreshTime: time,
        pageSize,
        pageNum: 1,
      })}`,
    );
  };

  // 翻页事件处理
  const handlePageChange = (p) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...query,
        pageNum: p.pageNum,
        pageSize: p.pageSize,
      })}`,
    );
  };

  // 重置事件处理
  const handleRestClick = (rs) => {
    history.replace(
      `${pathname}?${qs.stringify({
        ...rs,
        pageSize: 10,
        pageNum: 1,
      })}`,
    );
  };
  //获取总数据条数
  const fetchDataTotal = useCallback(() => {
    dispatch({
      type: 'adjustList/getTotalData',
      payload: {
        values: {},
      },
    });
  }, [dispatch]);
  useEffect(() => {
    fetchDataTotal();
  }, [fetchDataTotal]);
  // const pageSizeChange = (val) => {
  //   // setParams({
  //   //   ...params,
  //   //   page: 1,
  //   //   // limit: val,
  //   // });
  //   setLimit(val);
  //   setPage(1);
  // };

  // const pageNumChange = ({ current }) => {
  //   // console.log(current);
  //   setPage(current);
  // };

  //选择多个table
  const onSelect = () => {
    // setIdArr(val);
  };
  // //删除选择多个table
  // const handleDelete = () => {
  //   console.log('idArr:::', idArr);
  //   //调用接口
  //   message.success('操作成功');
  // };
  // //启动选择多个table
  // const handleOpen = () => {
  //   message.success('操作成功');
  // };
  // //g关闭选择多个table
  // const handleClose = () => {
  //   message.success('操作成功');
  // };

  // 获取会员等级列表
  useEffect(() => {
    dispatch({ type: 'adjustList/getLevels' });
  }, [dispatch]);

  const fetchData = useCallback(() => {
    let startTime = signUpDateStart;
    let endTime = signUpDateEnd;
    if (signUpDateStart) {
      startTime = dayjs(signUpDateStart).format('YYYY-MM-DD 00:00:00');
    }
    if (signUpDateEnd) {
      endTime = dayjs(signUpDateEnd).format('YYYY-MM-DD 23:59:59');
    }
    const registerStoreArray = registerStore ? registerStore?.split('/') : null;
    const manageStoreArray = manageStore ? manageStore?.split('/') : null;
    const values = {
      channel,
      gender,
      memberCode,
      mobile,
      registerStore: registerStoreArray,
      manageStore: manageStoreArray,
      signUpDateEnd: endTime,
      signUpDateStart: startTime,
      refreshTime,
      name,
      pageNum,
      pageSize,
      level,
      searchCount: false,
      // column: sort !== 'default' ? column : '',
      // sort: sort === 'ascend' ? 'ASC' : sort === 'descend' ? 'DESC' : '',
    };
    if (isSearch) {
      window.NE_DAWN.trigger(searchRef.current, {
        event: '_ec', // 事件名
        params: { ...values }, // 事件公参
      });
    }
    setIsSearch(false);
    dispatch({
      type: 'adjustList/getMemberList',
      payload: {
        values,
      },
    });
  }, [
    refreshTime,
    signUpDateStart,
    signUpDateEnd,
    registerStore,
    manageStore,
    dispatch,
    channel,
    gender,
    memberCode,
    mobile,
    name,
    pageNum,
    pageSize,
    level,
  ]);

  const fetchDataNum = useCallback(() => {
    let startTime = signUpDateStart;
    let endTime = signUpDateEnd;
    if (signUpDateStart) {
      startTime = dayjs(signUpDateStart).format('YYYY-MM-DD 00:00:00');
    }
    if (signUpDateEnd) {
      endTime = dayjs(signUpDateEnd).format('YYYY-MM-DD 23:59:59');
    }
    const registerStoreArray = registerStore ? registerStore?.split('/') : null;
    const manageStoreArray = manageStore ? manageStore?.split('/') : null;
    dispatch({
      type: 'adjustList/getMemberListNum',
      payload: {
        values: {
          channel,
          gender,
          memberCode,
          mobile,
          registerStore: registerStoreArray,
          manageStore: manageStoreArray,
          signUpDateEnd: endTime,
          signUpDateStart: startTime,
          refreshTime,
          name,
          pageNum,
          pageSize,
          level,
          searchCount: true,
          // column: sort !== 'default' ? column : '',
          // sort: sort === 'ascend' ? 'ASC' : sort === 'descend' ? 'DESC' : '',
        },
      },
    });
  }, [
    refreshTime,
    signUpDateStart,
    signUpDateEnd,
    registerStore,
    manageStore,
    dispatch,
    channel,
    gender,
    memberCode,
    mobile,
    name,
    pageNum,
    pageSize,
    level,
  ]);

  // 发起请求
  useEffect(() => {
    fetchData();
  }, [fetchData]);
  // 发起请求
  useEffect(() => {
    fetchDataNum();
  }, [fetchDataNum]);

  // 保存后弹出选择
  const handleOk2 = () => {
    setVisible2(true);
    history.push({
      pathname: '/cm/mm/ml',
      query: { id: memberInfo.id, status: 'edit' },
    });
  };
  // 保存后弹入选择
  const handleCancel2 = () => {
    setVisible2(false);
    fetchData();
  };

  let { data: members, total, hasNext } = memberPageList || {};

  return (
    <IndexStyled>
      <div
        data-log={JSON.stringify({
          oid: 'page_manual_adjustment_member_adjustment_list',
          isPage: true,
          params: {
            initUrl: window.location.origin + window.location.pathname,
          },
          events: ['_pv', '_pd'],
        })}
        className="mm_content"
      >
        <div className={classnames('search_group', 'single_component1')}>
          <SearchGroup
            searchRef={searchRef}
            levels={levels}
            query={query}
            handleSearch={(par) => handleSearch(par)}
            restClick={handleRestClick}
          />
        </div>
        {/* <div className="single_component2">
          <Button
            size="medium"
            fontsize="16px"
            onClick={edit}
            variant="contained"
          >
            新增
          </Button>
        </div> */}
        <ActionBtnGroup />
        <div className={classnames('table_page', 'single_component')}>
          {/* 默认使用loading包裹，使用tabel的loading会闪屏，且加载时tabel列头也加载 */}
          <TablePage
            pagination={{
              pageNum,
              pageSize,
            }}
            loading={loading}
            total={total}
            allTotal={allTotal}
            tableData={members}
            hasNext={hasNext}
            setPageData={handlePageChange}
            // pageSizeChange={pageSizeChange}
            // pageNumChange={pageNumChange}
            // loading={loading}
            setColumn={(e) => setColumn(e)}
            setSort={(e) => setSort(e)}
          />
        </div>
        <ModalML
          width="30vw"
          title="消息"
          visible={modalVisible2}
          handleOk={handleOk2}
          handleCancel={handleCancel2}
        >
          {/* <p className={styles.contentMsg}>新增成功</p> */}
          <div className="editDetail">
            <ButtonML
              size="large"
              value="返回列表"
              fontsize="16px"
              onClick={handleCancel2}
            />
            <ButtonML
              size="large"
              value="编辑详情"
              fontsize="16px"
              onClick={handleOk2}
            />
          </div>
        </ModalML>
      </div>
    </IndexStyled>
  );
};

export default MemberManagement;
